import React from "react";
import { PropertyGroupApiData } from "../propertyGroupModal";

interface MetaInfoSectionProps {
  formData: PropertyGroupApiData;
  onMetadataChange: (field: keyof PropertyGroupApiData["metadata"], value: string) => void;
  onKeywordChange: (index: number, value: string) => void;
  onSlugChange: (slug: string) => void;
}

const MetaInfoSection: React.FC<MetaInfoSectionProps> = ({
  formData,
  onMetadataChange,
  onKeywordChange,
  onSlugChange,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Meta Title *
        </label>
        <input
          type="text"
          value={formData.metadata.meta_title}
          onChange={(e) =>
            onMetadataChange("meta_title", e.target.value)
          }
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="SEO meta title"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Meta Description *
        </label>
        <textarea
          value={formData.metadata.meta_description}
          onChange={(e) =>
            onMetadataChange("meta_description", e.target.value)
          }
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="SEO meta description"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Slug *
        </label>
        <input
          type="text"
          value={formData.slug}
          onChange={(e) => onSlugChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="url-friendly-slug"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-3">
          Keywords (5 maximum)
        </label>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {formData.metadata.keywords.map(
            (keyword: string, index: number) => (
              <input
                key={index}
                type="text"
                value={keyword}
                onChange={(e) =>
                  onKeywordChange(index, e.target.value)
                }
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder={`Keyword ${index + 1}`}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default MetaInfoSection;

